import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { withApp, scrollTop } from 'helpers'
import { AppView, AppContainer, AppHeader, AppContent, AppLogo } from 'components/layout'
import { Animation, Page, PageHeader } from 'components/library'
import { Pages } from 'content/pages'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'

class PageView extends React.Component {
  componentDidMount() {
    scrollTop()
    this.setTheme()
    this.props.app.setLocation({ label: 'page', id: this.page.id })
  }

  setTheme() {
    const nav = this.props.navigation.find(item => item.pageId === this.page.id)
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  get page() {
    return this.props.pages.find(item => item.slug === this.props.match.params.page) || {}
  }

  updateProgress = () => {
    const nav = this.props.navigation.find(item => item.pageId === this.page.id)
    const progress = this.props.progress.find(item => item.id === nav.id)

    if(progress.status !== 'done') {
      this.props.accountActions.updateProgress(nav.id, 1)
      this.props.app.willProgress(nav)
    }
  }

  handleSubmit = e => {
    this.updateProgress()

    this.props.history.push(Routes.to('home'))
  }

  render() {
    if(this.page.id) {
      return (
        <AppView name="Page">
          {this.page.headerType === 'default' &&
            <AppHeader />
          }

          <AppContent>
            <AppContainer>
              <Page>
                {this.page.headerType === 'simple' &&
                  <Animation name="zoomIn">
                    <PageHeader>
                      <AppLogo />
                    </PageHeader>
                  </Animation>
                }

                <CurrentPage page={this.page} onSubmit={this.handleSubmit} updateProgress={this.updateProgress} user={this.props.user} />
              </Page>
            </AppContainer>
          </AppContent>
        </AppView>
      )
    }

    else {
      return <Redirect to={Routes.to('home')} />
    }
  }
}

const CurrentPage = props => {
  const Page = Pages[props.page.slug]

  if(!Page) return <p>No Template</p>

  return <Page {...props} />
}

export default withApp(connect(
  (state, props) => ({
    user: state.account.user,
    progress: state.account.progress,
    pages: state.content.pages,
    navigation: state.content.navigation,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(PageView))



// WEBPACK FOOTER //
// ./src/components/views/page/PageView.js